import { IndicatorFactorsPicker } from 'app/area/indicator-factors/types';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { ValidationProps } from 'ui/common/validation/types';
import { CodeItem, ReceiveCodeItemPayload } from './types-store';

export const ACTION = {
  REQUEST_CODE_ITEM: 'INDICATOR_FACTORS_ITEM:REQUEST_CODE_ITEM',
  RECEIVE_CODE_ITEM: 'INDICATOR_FACTORS_ITEM:RECEIVE_CODE_ITEM',
  FAIL_CODE_ITEM: 'INDICATOR_FACTORS_ITEM:FAIL_CODE_ITEM',

  CREATE_CODE_ITEM: 'INDICATOR_FACTORS_ITEM:CREATE_CODE_ITEM',

  REQUEST_SAVE_CODETABLE_ITEM: 'INDICATOR_FACTORS_ITEM:REQUEST_SAVE_CODETABLE_ITEM',
  RECEIVE_SAVE_CODETABLE_ITEM: 'INDICATOR_FACTORS_ITEM:RECEIVE_SAVE_CODETABLE_ITEM',
  FAIL_SAVE_CODETABLE_ITEM: 'INDICATOR_FACTORS_ITEM:FAIL_SAVE_CODETABLE_ITEM',

  REQUEST_CODE_ITEM_DELETE: 'INDICATOR_FACTORS_ITEM:REQUEST_CODE_ITEM_DELETE',
  RECEIVE_CODE_ITEM_DELETE: 'INDICATOR_FACTORS_ITEM:RECEIVE_CODE_ITEM_DELETE',
  FAIL_CODE_ITEM_DELETE: 'INDICATOR_FACTORS_ITEM:FAIL_CODE_ITEM_DELETE',

  UPDATE_VALIDATION: 'INDICATOR_FACTORS_ITEM:UPDATE_VALIDATION',
  RESET_VALIDATION: 'INDICATOR_FACTORS_ITEM:RESET_VALIDATION',
  UPDATE_BY_KEY: 'INDICATOR_FACTORS_ITEM:UPDATE_BY_KEY',
  CLEAR_VALIDATION: 'INDICATOR_FACTORS_ITEM:CLEAR_VALIDATION',

  CLEAR_CODETABLE_OPTIONS: 'INDICATOR_FACTORS_ITEM:CLEAR_CODETABLE_OPTIONS'
};

export class RequestCodeItem {
  public type: string = ACTION.REQUEST_CODE_ITEM;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ReceiveCodeItem {
  public type: string = ACTION.RECEIVE_CODE_ITEM;
  constructor(public payload: ReceiveCodeItemPayload) {
  }
}

export class FailCodeItem {
  public type: string = ACTION.FAIL_CODE_ITEM;
  constructor(public codetableId: number, public codeId: number) {
  }
}
export class CreateCodeItem {
  public type: string = ACTION.CREATE_CODE_ITEM;
  constructor(public codeItem: CodeItem) {
  }
}

export class RequestSaveCodetableItem {
  public type: string = ACTION.REQUEST_SAVE_CODETABLE_ITEM;
}

export class ReceiveSaveCodetableItem {
  public type: string = ACTION.RECEIVE_SAVE_CODETABLE_ITEM;
}

export class FailSaveCodetableItem {
  public type: string = ACTION.FAIL_SAVE_CODETABLE_ITEM;
}

export class RequestCodeItemDelete {
  public type: string = ACTION.REQUEST_CODE_ITEM_DELETE;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ReceiveCodeItemDelete {
  public type: string = ACTION.RECEIVE_CODE_ITEM_DELETE;
  constructor(public codeId: number) {
  }
}

export class FailCodeItemDelete {
  public type: string = ACTION.FAIL_CODE_ITEM_DELETE;
  constructor(public codeId: number) {
  }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: { [key: string]: ValidationProps }) {
  }
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public key: CodeFieldWireKey) {
  }
}

export class ClearValidation {
  public type: string = ACTION.CLEAR_VALIDATION;
}

export class ClearCodetableOptions {
  public type: string = ACTION.CLEAR_CODETABLE_OPTIONS;
}

export class UpdateByKey {
  public type: string = ACTION.UPDATE_BY_KEY;
  constructor(public key: IndicatorFactorsPicker | CodeFieldWireKey, public value: any) {
  }
}
